/**
 * Routes list
 * ORG API
 */
let _prefix = '/orgstructure/v1'

export default {
  companiesList: _prefix + '/companies',
  deleteCompany: _prefix + '/company-delete',
  companyHardDelete: _prefix + '/company-hard-delete',
  updateCompany: _prefix + '/company',
  restoreCompany: _prefix + '/company-restore',
  companyTree: _prefix + '/company-tree',
  containersTree: _prefix + '/parents-tree',
  updateContainer: _prefix + '/container',
  deleteContainer: _prefix + '/container-delete',
  containerHardDelete: _prefix + '/container-hard-delete',
  restoreContainer: _prefix + '/container-restore',
  updatePost: _prefix + '/post',
  deletePost: _prefix + '/post-delete',
  postHardDelete: _prefix + '/post-hard-delete',
  restorePost: _prefix + '/post-restore',
}



// WEBPACK FOOTER //
// ./src/api/orgstructure/routes.js